import { Component, ElementRef, Renderer2, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { DynamicHostDirective } from './dynamic-host.directive';
import { AbstractModal } from '../model/abstract.modal';
import { ModalConfigurationModel, ModalSize } from '../model/modal-configuration.model';

@Component({
	selector: 'cv-dynamic-host',
	styleUrls: ['./dynamic-host.component.scss'],
	encapsulation: ViewEncapsulation.None,
	templateUrl: './dynamic-host.component.html',
})
export class DynamicHostComponent {
	@ViewChild(DynamicHostDirective, { static: true }) dynamicContent: DynamicHostDirective;
	@ViewChildren('actionButtons') actionButtons: Array<ElementRef>;
	currentModalComponentInstance: AbstractModal;
	modalConfigurationModel = new ModalConfigurationModel();
	// Buttons
	showActionButtons = false;
	modalButtonsSize = 0;
	modalSize: ModalSize;
	modalSizeTypes = ModalSize;

	constructor(private renderer: Renderer2) {
		// Silence is golden
	}

	/**
	 * Enables all Dialogs actions
	 */
	publishDialog(): void {
		// Set the Title
		if(this.currentModalComponentInstance.setTitle) {
			this.currentModalComponentInstance.setTitle(this.modalConfigurationModel.title);
		}
		
		if (!this.currentModalComponentInstance) {
			// if instance is empty, does not show anything
			this.showActionButtons = false;
		} else {
			// Initial Buttons
			this.publishButtons();
			this.modalSize = this.modalConfigurationModel && this.modalConfigurationModel.modalSize
				? this.modalConfigurationModel.modalSize : ModalSize.MD;
			// if (this.modalConfigurationModel.fullScreen || this.modalConfigurationModel.defaultFullScreen) {
			// 	this.showFullScreen = true;
			// 	this.fullScreen = this.modalConfigurationModel.defaultFullScreen;
			// }

			// Listen to any change
			// setInterval(() => this.publishButtons(), 1000);
		}
	}

	/**
	 * Verify if new actions are coming to the Instance, to show Hide Sections
	 */
	publishButtons(): void {
		if (this.currentModalComponentInstance.buttons.length !== this.modalButtonsSize) {
			this.modalButtonsSize = this.currentModalComponentInstance.buttons.length;
			this.showActionButtons = this.modalButtonsSize > 0;
		}
	}
}
